import { Inject, Injectable } from '@angular/core';
import { Model, ModelFactory } from 'ngx-model';
import { Observable } from 'rxjs';
import { Pos } from '../classes/pos';
import { ApiEndpointsService } from './api-endpoints.service';
import { IHttpService } from './ihttp.service';
import { SortDirection } from 'src/app/directives/sortable/sortable.directive';
import { FilterSelection } from '../classes/filterSelection';
import { filter } from 'rxjs/operators';

interface State {
  page: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: SortDirection;
}

@Injectable()
export class PosService {
  private model: Model<Pos[]>;
  pos$: Observable<Pos[]>;

  private modelFiltered: Model<Pos[]>;
  posFiltered$: Observable<Pos[]>;

  private _state: State = {
    page: 1,
    pageSize: 4,
    sortColumn: '',
    sortDirection: '',
  };

  private currentFilter = new FilterSelection();

  constructor(
    private modelFactory: ModelFactory<Pos[]>,
    private apiEndpointsService: ApiEndpointsService,
    @Inject('HttpService') private httpService: IHttpService
  ) {
    //Todos los datos
    this.model = this.modelFactory.create([]);
    this.pos$ = this.model.data$;

    //Datos filtrados visibles en pantalla
    this.modelFiltered = this.modelFactory.create([]);
    this.posFiltered$ = this.modelFiltered.data$;
  }

  getPos(): Pos[] {
    return this.model.get();
  }

  setPos(data: Pos[]) {
    this.model.set(data);
  }

  getPosFiltered(): Pos[] {
    return this.modelFiltered.get();
  }

  setPosFiltered(data: Pos[]) {
    this.modelFiltered.set(data);
  }

  iniPos() {
    let filter = new FilterSelection();
    let posList: Pos[] = [];
    filter.skipToken = 0;
    this.httpService
      .get(this.apiEndpointsService.getPosEndpointFromPos(filter))
      .subscribe((data) => {
        posList = this.loadData(data, posList);
        if (data['@odata.nextLink'] != null && data['@odata.nextLink'] != '') {
          filter.skipToken = filter.skipToken + 1000;
          this.httpService
            .get(this.apiEndpointsService.getPosEndpointFromPos(filter))
            .subscribe((data) => {
              posList = this.loadData(data, posList);
              if (
                data['@odata.nextLink'] != null &&
                data['@odata.nextLink'] != ''
              ) {
                filter.skipToken = filter.skipToken + 1000;
                this.httpService
                  .get(this.apiEndpointsService.getPosEndpointFromPos(filter))
                  .subscribe((data) => {
                    posList = this.loadData(data, posList);
                    if (
                      data['@odata.nextLink'] != null &&
                      data['@odata.nextLink'] != ''
                    ) {
                      filter.skipToken = filter.skipToken + 1000;
                      this.httpService
                        .get(
                          this.apiEndpointsService.getPosEndpointFromPos(filter)
                        )
                        .subscribe((data) => {
                          posList = this.loadData(data, posList);
                          if (
                            data['@odata.nextLink'] != null &&
                            data['@odata.nextLink'] != ''
                          ) {
                            filter.skipToken = filter.skipToken + 1000;
                            this.httpService
                              .get(
                                this.apiEndpointsService.getPosEndpointFromPos(
                                  filter
                                )
                              )
                              .subscribe((data) => {
                                posList = this.loadData(data, posList);
                                if (
                                  data['@odata.nextLink'] != null &&
                                  data['@odata.nextLink'] != ''
                                ) {
                                  filter.skipToken = filter.skipToken + 1000;
                                  this.httpService
                                    .get(
                                      this.apiEndpointsService.getPosEndpointFromPos(
                                        filter
                                      )
                                    )
                                    .subscribe((data) => {
                                      posList = this.loadData(data, posList);
                                      if (
                                        data['@odata.nextLink'] != null &&
                                        data['@odata.nextLink'] != ''
                                      ) {
                                        filter.skipToken =
                                          filter.skipToken + 1000;
                                        this.httpService
                                          .get(
                                            this.apiEndpointsService.getPosEndpointFromPos(
                                              filter
                                            )
                                          )
                                          .subscribe((data) => {
                                            posList = this.loadData(
                                              data,
                                              posList
                                            );
                                            if (
                                              data['@odata.nextLink'] != null &&
                                              data['@odata.nextLink'] != ''
                                            ) {
                                              filter.skipToken =
                                                filter.skipToken + 1000;
                                              this.httpService
                                                .get(
                                                  this.apiEndpointsService.getPosEndpointFromPos(
                                                    filter
                                                  )
                                                )
                                                .subscribe((data) => {
                                                  posList = this.loadData(
                                                    data,
                                                    posList
                                                  );
                                                  if (
                                                    data['@odata.nextLink'] !=
                                                    null &&
                                                    data['@odata.nextLink'] !=
                                                    ''
                                                  ) {
                                                    filter.skipToken =
                                                      filter.skipToken + 1000;
                                                    this.httpService
                                                      .get(
                                                        this.apiEndpointsService.getPosEndpointFromPos(
                                                          filter
                                                        )
                                                      )
                                                      .subscribe((data) => {
                                                        posList = this.loadData(
                                                          data,
                                                          posList
                                                        );
                                                        if (
                                                          data[
                                                          '@odata.nextLink'
                                                          ] != null &&
                                                          data[
                                                          '@odata.nextLink'
                                                          ] != ''
                                                        ) {
                                                          this.model.set(
                                                            posList
                                                          );
                                                          this.modelFiltered.set(
                                                            posList
                                                          );
                                                        } else {
                                                          this.model.set(
                                                            posList
                                                          );
                                                          this.modelFiltered.set(
                                                            posList
                                                          );
                                                        }
                                                      });
                                                    this.model.set(posList);
                                                    this.modelFiltered.set(
                                                      posList
                                                    );
                                                  } else {
                                                    this.model.set(posList);
                                                    this.modelFiltered.set(
                                                      posList
                                                    );
                                                  }
                                                });
                                              this.model.set(posList);
                                              this.modelFiltered.set(posList);
                                            } else {
                                              this.model.set(posList);
                                              this.modelFiltered.set(posList);
                                            }
                                          });
                                        this.model.set(posList);
                                        this.modelFiltered.set(posList);
                                      } else {
                                        this.model.set(posList);
                                        this.modelFiltered.set(posList);
                                      }
                                    });
                                  this.model.set(posList);
                                  this.modelFiltered.set(posList);
                                } else {
                                  this.model.set(posList);
                                  this.modelFiltered.set(posList);
                                }
                              });
                            this.model.set(posList);
                            this.modelFiltered.set(posList);
                          } else {
                            this.model.set(posList);
                            this.modelFiltered.set(posList);
                          }
                        });
                      this.model.set(posList);
                      this.modelFiltered.set(posList);
                    } else {
                      this.model.set(posList);
                      this.modelFiltered.set(posList);
                    }
                  });
              } else {
                this.model.set(posList);
                this.modelFiltered.set(posList);
              }
            });
        } else {
          this.model.set(posList);
          this.modelFiltered.set(posList);
        }
      });
  }

  private loadData(data: any, posList: Pos[]) {
    for (let entry of data.value) {
      let p = new Pos(entry.POS, entry.COMERCIALNAME, entry.FISCALNAME);
      p.address = entry.FULLADDRESS;
      p.lat = entry.SHIPPINGLATITUDE;
      p.lon = entry.SHIPPINGLONGITUDE;
      p.openIndicator = entry.OPENINGHOURSINDICATOR;
      p.contactIndicator = entry.CONTACTINDICATOR;
      p.shippingStreet = entry.SHIPPINGSTREET;
      p.shippingCity = entry.SHIPPINGCITY;
      p.shippingPostalCode = entry.SHIPPINGPOSTALCODE;
      p.shippingCountry = entry.SHIPPINGCOUNTRY;
      p.shippingState = entry.SHIPPINGSTATE;
      p.origin = entry.ORIGIN;
      posList.push(p);
    }
    return posList;
  }

  isEmpty(filter: FilterSelection): boolean {
    //console.log(filter);
    return (
      filter.brand == '' &&
      filter.subbrand == '' &&
      filter.line == '' &&
      filter.format == '' &&
      filter.country == '' &&
      filter.region == '' &&
      filter.subregion == ''
    );
  }

  applyServerFilter(filter: FilterSelection) {
    let posList: Pos[] = [];
    let url = '';
    if (this.isEmpty(filter)) {
      this.iniPos();
    } else {
      this.currentFilter = filter;
      this.httpService
        .get(this.apiEndpointsService.getPosEndpoint(filter))
        .subscribe((data) => {
          posList = this.loadData(data, posList);
          this.model.set(posList);
          this.modelFiltered.set(posList);
        });
    }
  }

  filterPos(searchText: string) {
    searchText = searchText?.toLowerCase();
    //console.log(searchText);

    if (searchText.length === 0) {
      this.modelFiltered.set(this.model.get());
    }
    else if (searchText.length === 4) {
      let posList: Pos[] = [];
      this.httpService.get(this.apiEndpointsService.getPosEndpointFromPos(this.currentFilter)).subscribe((data) => {
        posList = this.loadData(data, posList);
        this.onFilterPos(searchText);
      });
    } else {
      this.onFilterPos(searchText);
    }

    
  }

  filterPosLatLon(bounds: google.maps.LatLngBounds) {
    this.setPosFiltered(
      this.getPos().filter((p) => this.inBounds(p.lat!, p.lon!, bounds))
    );
  }

  private onFilterPos(searchText: string) {
    this.setPosFiltered(
      this.getPos().filter(
        (p) =>
          p.commercialName?.toLowerCase().includes(searchText) ||
          p.fiscalName?.toLowerCase().includes(searchText) ||
          p.address?.toLowerCase().includes(searchText)
      )
    );
  }

  private inBounds(lat: number, lon: number, bounds: google.maps.LatLngBounds) {
    var eastBound = lon < bounds.getNorthEast().lng();
    var westBound = lon > bounds.getSouthWest().lng();
    var inLong;

    if (bounds.getNorthEast().lng() < bounds.getSouthWest().lng()) {
      inLong = eastBound || westBound;
    } else {
      inLong = eastBound && westBound;
    }

    var inLat =
      lat > bounds.getSouthWest().lat() && lat < bounds.getNorthEast().lat();
    return inLat && inLong;
  }

  set sortColumn(sortColumn: string) {
    this._set({ sortColumn });
  }
  set sortDirection(sortDirection: SortDirection) {
    this._set({ sortDirection });
  }
  private _set(patch: Partial<State>) {
    Object.assign(this._state, patch);
    this.sort();
  }

  private sort() {
    const { sortColumn, sortDirection, pageSize, page } = this._state;

    // 1. sort
    this.setPosFiltered(sort(this.getPos(), sortColumn, sortDirection));
  }
}

const compare = (v1: string | number, v2: string | number) =>
  v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

function sort(pos: Pos[], column: string, direction: string): Pos[] {
  if (direction === '' || column === '') {
    return pos;
  } else {
    return [...pos].sort((a, b) => {
      const res = compare((a as any)[column]!, (b as any)[column]!);
      return direction === 'asc' ? res : -res;
    });
  }
}
